export default function (element, data) {
    const selectElem = element.querySelector(".select");
    const param = data.param;
    const redirect = data.redirect == true;

    selectElem.addEventListener("change", function (event) {
        let value = selectElem.value;

        if (!param && redirect && value) {
            window.location.href = value;
            return;
        }

        if (param) {
            let url = new URL(window.location.href);
    
            if (value === "" || value === "all") {
                url.searchParams.delete(param);
            } else {
                url.searchParams.set(param, value);
            }
    
            window.location.href = url;
        }
    });
};